import ResetMultiFactor from './ResetMultiFactor'

export default ResetMultiFactor;
